var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconIos = function SvgIconIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 6 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M5.744 2.855c-.042.032-.78.448-.78 1.371 0 1.07.939 1.447.967 1.456a3.8 3.8 0 0 1-.495 1.022c-.308.444-.63.887-1.12.887s-.615-.285-1.18-.285c-.551 0-.747.294-1.195.294s-.76-.41-1.12-.914A4.4 4.4 0 0 1 .07 4.3c0-1.4.91-2.142 1.806-2.142.476 0 .873.313 1.171.313.285 0 .728-.332 1.27-.332.205 0 .942.02 1.428.715M4.059 1.548c.224-.266.382-.635.382-1.003A.7.7 0 0 0 4.427.4c-.364.014-.797.243-1.059.546-.205.233-.397.602-.397.976 0 .056.01.112.014.13.023.004.06.01.098.01.327 0 .738-.22.976-.514"
  })));
};
export default SvgIconIos;